import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Optional,
  Output,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConfirmDialogData {
  title: string;
  message: string;
  confirm?: boolean;
  iconExtra?: boolean;
  overlayIcon?: string;
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent implements OnInit {
  /**
   * Dati del dialog. Quando il componente è usato inline
   * (<app-confirm-dialog [data]="...">) viene popolato via @Input;
   * quando è aperto via MatDialog viene iniettato tramite MAT_DIALOG_DATA.
   */
  @Input() data: ConfirmDialogData;

  /**
   * Emesso quando l'utente conferma o annulla. Usato solo nella modalità inline.
   */
  @Output() closeDialog = new EventEmitter<ConfirmDialogData>();

  iconExtra: boolean;
  overlayIcon: string;

  constructor(
    @Optional() public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) injectedData: ConfirmDialogData
  ) {
    if (injectedData) {
      this.data = injectedData;
    }
  }

  ngOnInit(): void {
    this.iconExtra = this.data?.iconExtra ?? false;
    this.overlayIcon = this.data?.overlayIcon ?? '';
  }

  confirmChoice(choice: boolean): void {
    this.data.confirm = choice;
    this.emitOrClose();
  }

  onNoClick(): void {
    this.data.confirm = false;
    this.emitOrClose();
  }

  private emitOrClose(): void {
    if (this.dialogRef) {
      this.dialogRef.close(this.data);
    } else {
      this.closeDialog.emit(this.data);
    }
  }
}
